<!-- 新闻列表 右侧最新咨询 -->
<template>
    <div class="Heziyun-populars">
        <div class="Heziyun-title"></div>
        <div class="Heziyun-allRankings" v-skeleton="{ show: recently.length == 0 }">
            <a :href="'/news/' + item.id + '.html'" class="Heziyun-item" v-for="(item, index) in recently"
                :key="item.id">
                <div class="Heziyun-whole">
                    <div class="Heziyun-inblock">
                        <span :style="{ color: 'rgb(' + getStyle(index + 1) + ')' }">{{ index + 1 }}</span>
                        <p :title="item.title">{{ item.title }}</p>
                    </div>
                    <div class="Heziyun-label">
                        <div class="Heziyun-source" v-show="detailscontent">{{ detailscontent }}</div>
                        <div class="Heziyun-time" v-skeleton="{ show: !item.create_time }">
                            {{ item.create_time ? formatTimestamp(item.create_time) : '' }}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import axios from 'axios'

const props = defineProps({
    detailscontent: {
        type: String,
        required: false,
        default: ''
    }
})

const recently = ref([])

// 排名颜色
const getStyle = (index) => {
    switch (index) {
        case 1: return '56, 111, 231'
        case 2: return '73, 134, 254'
        case 3: return '100, 216, 255'
        default: return '167, 172, 203'
    }
}

// 方法：将时间戳转换为格式化字符串
const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000) // 假设是秒级时间戳（需乘以1000）
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
}

// 最近更新
const recentlyUpdated = async () => {
    try {
        const res = await axios.get(`/console/v1/news?page=1&limit=5`)
        recently.value = res.data.data.list

        if (res.data.data.list.length == 0) {
            recently.value = true
        }
    } catch (error) {
        console.error('获取最近更新失败:', error)
    }
}

onMounted(() => {
    // 最近更新
    recentlyUpdated()
})
</script>

<style lang="less" scoped>
.Heziyun-populars {
    width: 25%;
    height: max-content;
    background-color: #fff;
    border-radius: 0.5rem;
    -webkit-border-radius: 0.5rem;
    -moz-border-radius: 0.5rem;
    -ms-border-radius: 0.5rem;
    -o-border-radius: 0.5rem;
    overflow: hidden;
    position: sticky;
    top: 4rem;
    font-family: "思源黑";
    background: linear-gradient(1turn, #fff, #f7f9fd);
    border: 2px solid #fff;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
}

.Heziyun-populars .Heziyun-title {
    background: url("@/static/img/new_Smell/remen2.png") no-repeat center;
    background-size: 100% 100%;
    min-height: 7rem;
    box-shadow: 0 4px 10px rgba(20, 100, 255, 0.1);
}

.Heziyun-populars .Heziyun-allRankings {
    display: flex;
    flex-direction: column;
    min-height: 25rem;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item {
    padding: 1rem 1.5rem;
    cursor: pointer;
    position: relative;
}


.Heziyun-populars .Heziyun-allRankings .Heziyun-item:hover {
    background-color: #f2f2f2;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item:hover .Heziyun-whole .Heziyun-label .Heziyun-source {
    background-color: rgb(2, 84, 255);
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-inblock {
    display: flex;
    gap: 0.5rem;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-inblock span {
    font-size: 1.5rem;
    font-family: "Title";
    line-height: 1;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-inblock p {
    color: rgb(68, 68, 68);
    font-size: 0.8rem;
    line-height: 1.7;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 1.5rem;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-label .Heziyun-source {
    background-color: rgb(2, 84, 255);
    padding: 0.1rem 0.5rem;
    color: #fff;
    border-radius: 10rem;
    -webkit-border-radius: 10rem;
    -moz-border-radius: 10rem;
    -ms-border-radius: 10rem;
    -o-border-radius: 10rem;
    font-size: 0.6rem;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-label .Heziyun-time {
    color: rgb(190, 190, 215);
    font-size: 0.8rem;
}

.Heziyun-populars .Heziyun-allRankings .Heziyun-item:not(:first-child) {
    position: relative;
}

@media (max-width: 768px) {
    .Heziyun-populars {
        width: 100%;
        border-radius: 2vw;
        -webkit-border-radius: 2vw;
        -moz-border-radius: 2vw;
        -ms-border-radius: 2vw;
        -o-border-radius: 2vw;
        position: initial;
    }

    .Heziyun-populars .Heziyun-title {
        background-size: 100%;
        min-height: 30vw;
    }

    .Heziyun-populars .Heziyun-allRankings {
        display: flex;
        flex-direction: column;
        min-height: 107vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item {
        padding: 3vw 4vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole {
        gap: 3vw;
        font-family: "思源黑";
        position: relative;
        z-index: 1;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-inblock {
        gap: 2vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-inblock span {
        font-size: 6vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-inblock p {
        font-size: 4vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-label {
        padding-left: 5vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-label .Heziyun-source {
        padding: 0.6vw 2vw;
        font-size: 3vw;
    }

    .Heziyun-populars .Heziyun-allRankings .Heziyun-item .Heziyun-whole .Heziyun-label .Heziyun-time {
        color: rgb(190, 190, 215);
        font-size: 3vw;
    }
}
</style>